/*******************************************************************
 * NGX-DYNAMIC-MATERIAL-TABLE                                      *
 * @description Create fancy and complex tables dynamically        *
 * @file dynamic-table-column-definition.constants.                *
 * @author GÃ¶khan Sari - <goekhan.sari@arpage.ch>                  *
 * @copyright Arpage AG, Zurich Switzerland, 2018                  *
 *******************************************************************/
export class DynamicTableColumnDefinitionConstants {

    public static readonly INDICATOR_COLOR = 'indicatorColor';
    public static readonly HTML_ICON = 'htmlIcon';
    public static readonly TITLE = 'title';
    public static readonly ADDITIONAL_INFO = 'additionalInfo';
    public static readonly DESCRIPTION = 'description';
    public static readonly HTML_CONTENT_SUMMARY = 'htmlContentSummary';
    public static readonly HTML_ACTIONS = 'htmlActions';
    public static readonly OTHER_TEXT_BASED1 = 'otherTextBased1';
    public static readonly OTHER_TEXT_BASED2 = 'otherTextBased2';
    public static readonly OTHER_TEXT_BASED3 = 'otherTextBased3';
    public static readonly OTHER_TEXT_BASED4 = 'otherTextBased4';

    get INDICATOR_COLOR() {
        return DynamicTableColumnDefinitionConstants.INDICATOR_COLOR;
    }

    get HTML_ICON() {
        return DynamicTableColumnDefinitionConstants.HTML_ICON;
    }

    get TITLE() {
        return DynamicTableColumnDefinitionConstants.TITLE;
    }

    get ADDITIONAL_INFO() {
        return DynamicTableColumnDefinitionConstants.ADDITIONAL_INFO;
    }

    get DESCRIPTION() {
        return DynamicTableColumnDefinitionConstants.DESCRIPTION;
    }

    get HTML_CONTENT_SUMMARY() {
        return DynamicTableColumnDefinitionConstants.HTML_CONTENT_SUMMARY;
    }

    get HTML_ACTIONS() {
        return DynamicTableColumnDefinitionConstants.HTML_ACTIONS;
    }

    get OTHER_TEXT_BASED1() {
        return DynamicTableColumnDefinitionConstants.OTHER_TEXT_BASED1;
    }

    get OTHER_TEXT_BASED2() {
        return DynamicTableColumnDefinitionConstants.OTHER_TEXT_BASED2;
    }

    get OTHER_TEXT_BASED3() {
        return DynamicTableColumnDefinitionConstants.OTHER_TEXT_BASED3;
    }

    get OTHER_TEXT_BASED4() {
        return DynamicTableColumnDefinitionConstants.OTHER_TEXT_BASED4;
    }


}
